<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ options.title | translate }}</p>
  </div>
  <div class="modal-body py-4">
    <div class="row">
      <div [innerHtml]="options.message | translate"></div>
    </div>
  </div>
  <div class="modal-footer py-2">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear me-2"
      (click)="ok()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
